/**
 * @generated SignedSource<<86fbaa8ed452c4f506231bff4ced59b3>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ui_nativeIssueTable_NativeIssueTable_project$data = {
  readonly createIssues?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly editIssues?: {
    readonly canPerform: boolean;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"issueTable_nativeIssueTable_project" | "realtimeUpdater_nativeIssueTable_project">;
  readonly " $fragmentType": "ui_nativeIssueTable_NativeIssueTable_project";
};
export type ui_nativeIssueTable_NativeIssueTable_project$key = {
  readonly " $data"?: ui_nativeIssueTable_NativeIssueTable_project$data;
  readonly " $fragmentSpreads": FragmentRefs<"ui_nativeIssueTable_NativeIssueTable_project">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "kind": "ScalarField",
    "name": "canPerform"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider"
    },
    {
      "kind": "RootArgument",
      "name": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider"
    },
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "isConditionalFormattingEnabled"
    }
  ],
  "kind": "Fragment",
  "name": "ui_nativeIssueTable_NativeIssueTable_project",
  "selections": [
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistreparentingrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "editIssues",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "EDIT_ISSUES"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "action(type:\"EDIT_ISSUES\")"
        }
      ]
    },
    {
      "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcjiralistcheckissuecreatepermissionsrelayprovider",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "createIssues",
          "args": [
            {
              "kind": "Literal",
              "name": "type",
              "value": "CREATE_ISSUES"
            }
          ],
          "concreteType": "JiraProjectAction",
          "kind": "LinkedField",
          "name": "action",
          "plural": false,
          "selections": (v0/*: any*/),
          "storageKey": "action(type:\"CREATE_ISSUES\")"
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "realtimeUpdater_nativeIssueTable_project"
    },
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isConditionalFormattingEnabled",
          "variableName": "isConditionalFormattingEnabled"
        }
      ],
      "kind": "FragmentSpread",
      "name": "issueTable_nativeIssueTable_project"
    }
  ],
  "type": "JiraProject"
};
})();

(node as any).hash = "ab735a43d3d8e83ad25eaeee083a7d37";

export default node;
